import React, {Component} from "react"
import PropTypes from "prop-types"
import "./AttendanceStatus.css"
import Icon from '../../atoms/Icon';
import ButtonGroup from '../../molecules/ButtonGroup';

const attendanceOptions = [
  {
    value: true,
    label: <Icon icon="ok" />,
  },
  {
    value: false,
    label: <Icon icon="cancel" />,
  },
  {
    value: null,
    label: <Icon icon="help" />,
  },
];

class AttendanceStatus extends Component {
  render() {
    const {
      attendanceStatus,
      updateStagAttendance,
    } = this.props;

    const updateAttendanceStatus = (attending) => {
      updateStagAttendance(attending);
    };

    return (
      <div className="AttendanceStatus">
        <ButtonGroup
          options={attendanceOptions}
          value={typeof attendanceStatus === "boolean" ? attendanceStatus : null}
          onChange={updateAttendanceStatus}
          small={false}
        />
      </div>
    )
  }
}

AttendanceStatus.propTypes = {
  attendanceStatus: PropTypes.oneOf([
    null,
    true,
    false,
  ]),
  updateStagAttendance: PropTypes.func.isRequired,
}

export default AttendanceStatus



// WEBPACK FOOTER //
// ./src/component/organisms/AttendanceStatus/component.js